/* Use breakpoints from @dds-core */

export default {
  DESKTOP: 1200, // @dds-breakpoint-desktop-up
  TABLET_LANDSCAPE: 900, // @dds-breakpoint-tablet-landscape-up
  TABLET_PORTRAIT: 600, // @dds-breakpoint-tablet-portrait-up
};
